"use client";

import AuthRequiredContent from "../../common/basket/AuthRequiredContent";

interface Props {
  onClose: () => void;
  title?: string;
  description?: string;
  continueHref?: string;
  onContinueClick?: () => void;
}

const AuthRequiredModal = ({ onClose, title, description, continueHref, onContinueClick }: Props) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9991]">
      {/* BACKDROP */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* MODAL */}
      <div className="relative bg-white rounded-xl w-full max-w-md shadow-xl z-[9992]">
        <AuthRequiredContent title={title} description={description} continueHref={continueHref} onContinueClick={onContinueClick} />
      </div>
    </div>
  );
};

export default AuthRequiredModal;
